import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const MediaPreviousIcon = createSvgIcon(
  [
    <path
      d="M25.1377 6.78532C25.5778 6.46017 26.2005 6.77434 26.2005 7.32151V24.6785C26.2005 25.2257 25.5777 25.5398 25.1377 25.2147L13.3924 16.5358C13.0317 16.2693 13.0317 15.7299 13.3924 15.4634L25.1377 6.78532Z"
      key="0"
    />,
    <path
      d="M8 6.6667C8.36819 6.6667 8.66667 6.96518 8.66667 7.33337V24.6667C8.66667 25.0349 8.36819 25.3334 8 25.3334H6C5.63181 25.3334 5.33333 25.0349 5.33333 24.6667V7.33337C5.33333 6.96518 5.63181 6.6667 6 6.6667H8Z"
      key="1"
    />,
  ],
  'MediaPrevious',
  '0 0 32 32',
);
